export default __webpack_public_path__ + "static/media/1s.e440ef5b.svg";